import React from 'react';
import './style.css'
import { Box, Button, Grid } from '@mui/material';
import Graph from '../../component/Graph';
import refresh from '../../assets/img/refresh-icon.png'
import { t } from 'i18next';

const GraphSection = () => {
    return (
        <Box className="graph-section">
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginTop: '40px',
                gap: '20px'
            }}>
                <Box className='input-box'>
                    <input placeholder='05.05.2022 - 11.05.2022' />
                    <Button className='filter-btn'>{t("filter_date")}</Button>
                </Box>
                <Button className="refresh-btn"><img src={refresh} />{t("reset_btn")}</Button>
            </Box>
            <Grid container spacing={2} className='graph-wrap'>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Graph count={t("total_order")} subtitle="$12938.23" title={t("revenue_detail")} />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Graph count={t("total_order")} subtitle="2938" title={t("orders_detail")} />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Graph count={t("total_order")} subtitle="2938" title={t("locations_detail")} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default GraphSection;
